;(function () {
  'use strict'

  // Set by AbstractFormServlet#sendRedirect on the server side when a form
  // submission successfully redirects to a "thank you" target (see
  // FORM_PROPERTY_REDIRECT / THANK_YOU_QUERY_PARAM). Runs on every page load
  // since the redirect target isn't necessarily a dedicated Thank You
  // component - it can be any page configured in the form's "redirect" field.
  function onDocumentReady() {
    const url = new URL(window.location.href)

    if (url.searchParams.get('formSubmitted') !== 'true') {
      return
    }

    window.adobeDataLayer = window.adobeDataLayer || []
    window.adobeDataLayer.push({
      event: 'form submitted',
      eventInfo: {
        reference: 'thank you page',
      },
    })

    // Strip the marker from the URL (without reloading) so refreshing the
    // thank-you page doesn't push the event again. Other query params and the
    // path/hash are preserved. Launch's URL-based rules match on the path, not
    // this param, so they're unaffected.
    url.searchParams.delete('formSubmitted')
    window.history.replaceState(window.history.state, '', url.toString())
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
